module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/243-canada-0c6292f48100c5acc7ced3512ca72981.svg";